import React, {FC, useState} from 'react';

import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {reportToBugsnag} from '../../helpers/bugsnag';
import {postSurvey} from '../../helpers/http';
import {BannerError} from '../common/error/bannerError';
import {FrontPower} from '../common/frontPower';
import {MainContentWrapper} from '../common/mainContentWrapper';
import {SurveyForm} from './surveyForm';
import {useSurveyRouterData} from './surveyRoutesHelpers';
import {SurveySubmitted} from './surveySubmitted';

/*
 * Types.
 */

enum SurveyErrorsEnum {
  ALREADY_SUBMITTED = 'Survey already submitted',
  SUBMIT_FAILED = 'Failed sending feedback, please try again later',
}

/*
 * Components.
 */

export const SurveyPage: FC = () => {
  const routerData = useSurveyRouterData();
  const [isSurveySubmited, setIsSurveySubmited] = useState<boolean>(false);
  const [isFormSubmitting, setIsFormSubmitting] = useState<boolean>(false);
  const [error, setError] = useState<string | undefined>();
  const dismissError = () => setError(undefined);

  const onFormSubmit = async (score: number, note?: string, contact?: string) => {
    setIsFormSubmitting(true);
    try {
      await postSurvey(routerData, score, note, contact);
      setIsSurveySubmited(true);
    } catch (err) {
      if (err.response?.status === 403) {
        setError(SurveyErrorsEnum.ALREADY_SUBMITTED);
      } else {
        setError(SurveyErrorsEnum.SUBMIT_FAILED);
        reportToBugsnag(new Error(`Failed to submit survey: ${err.response?.data?.reason}`));
      }
    }
    setIsFormSubmitting(false);
  };

  return (
    <>
      <MainContentWrapper>
        {maybeRenderError(dismissError, error)}
        {isSurveySubmited ? (
          <SurveySubmitted />
        ) : (
          <SurveyForm
            routeScore={routerData.score}
            includeContactInput={routerData.includeContactInput ?? false}
            submitForm={onFormSubmit}
            isFormSubmitting={isFormSubmitting}
          />
        )}
      </MainContentWrapper>
      <FrontPower />
    </>
  );
};

/*
 * Helpers.
 */

function maybeRenderError(dismissError: Handler, error?: string) {
  if (!error) {
    return null;
  }
  return <BannerError description={error} onDismiss={dismissError} />;
}
